<template>
  <div class="py-8 px-6 h-full box-border examine-process">
    <div class="process-items flex">
      <div v-if="[1,3].includes(examineDetails.examineStatus)" class="time-line">
        <i>1</i>
        <div class="line"></div>
      </div>
      <div v-else class="time-line">
        <i class="icon-duigou"></i>
        <div class="line active-col"></div>
      </div>
      <div class="process1-content  ml-4">
        <div class="rounded-sm flex items-center">
          <span class="sms-title font-semibold">短信额度审核</span>
          <template v-if="examineDetails.examineStatus === 1">
            <div>
              <span class="status-pendding px-1 leading-22 ml-2 rounded-sm inline-block">审核中</span>
            </div>
            <div>
              <span class="btn-update ml-1 cursor-pointer" @click="onCancel">取消</span>
            </div>
          </template>
          <template v-if="examineDetails.examineStatus === 3">
            <fixed-tooltip
                class="ml-2"
                :content="examineDetails.examineInfo"
                wrap-class="status-fail px-1 rounded-sm "
            >
              <span class="leading-22 ">审核拒绝 {{ examineDetails.examineInfo }}</span>
            </fixed-tooltip>
            <div>
              <span class="btn-update ml-1 cursor-pointer" @click="updateExamine">修改</span>
            </div>
            <div>
              <span class="btn-update ml-1 cursor-pointer" @click="onCancel">取消</span>
            </div>
          </template>
          <template v-if="examineDetails.examineStatus === 2">
            <fixed-tooltip
                class="ml-2"
                :content="examineDetails.examineInfo"
                wrap-class="status-success px-1 rounded-sm"
            >
              <span class="leading-22 ">审核通过 {{ examineDetails.examineInfo }}</span>
            </fixed-tooltip>
          </template>
        </div>
        <div class="mt-1 font-normal leading-5 text-theme-black-650 text-sm">
          清研公司的短信费用将由财务在年底统一入账到项目中，您可在【费用结算-我发起的】查看所有短信费用
        </div>
        <div class="sms-text mt-6">
          <h2 class="sms-title text-theme-black-850 font-normal">短信模版内容</h2>
          <div class="sms-links p-3 text-theme-black-650 leading-5 mt-3">
            {{ smsDetailsInfo.smsTemplate }}
          </div>
        </div>
        <div class="sms-text mt-6">
          <h2 class="sms-title text-theme-black-850 font-normal mb-3">本次发送短信</h2>
          <div class="flex">
            <div class="flex-col">
              <div class="flex mb-3">
                <div class="label">条数</div>
                <div class="value">{{ smsDetailsInfo.smsQuantity }}</div>
              </div>
              <div class="flex mb-3">
                <div class="label">收信人数量</div>
                <div class="value">{{ smsDetailsInfo.smsPerson }}</div>
              </div>
              <div class="flex mb-3">
                <div class="label">内容字符数</div>
                <div class="value">{{ smsDetailsInfo.chartNum }}</div>
              </div>
              <div class="flex mb-3">
                <div class="label">短信总金额(元)</div>
                <div class="value">{{ smsDetailsInfo.smsTotalAmount }}</div>
              </div>
            </div>
            <div class="flex-col ml-4">
              <div class="flex mb-3">
                <div class="label">项目名称</div>
                <div class="value">{{ smsDetailsInfo.projectName }}</div>
              </div>
              <div class="flex mb-3">
                <div class="label">项目编号</div>
                <div class="value">{{ smsDetailsInfo.projectId }}</div>
              </div>
              <div class="flex mb-3">
                <div class="label">所属部门</div>
                <div class="value">{{ smsDetailsInfo.departmentName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="examineDetails.examineStatus!==3" class="process-items flex mt-3" >
      <div class="time-line">
        <i>2</i>
        <div class="line hidden"></div>
      </div>
      <div class="process1-content ml-4">
        <div class="text-theme-black-850 rounded-sm flex items-center">
          <span class="sms-title font-semibold	">短信群发审核</span>
          <template v-if="examineDetails.examineStatus!==2">
            <div>
              <span class="text-theme-black-650 text-medium ml-2">未开始</span>
            </div>
            <el-tooltip content="短信配额审核通过后进入短信群发审核">
                    <span class="text-theme-black-650 text-medium ml-1">
                      <i class="icon-yiwen"></i>
                    </span>
            </el-tooltip>
          </template>
          <template v-if="smsResult.auditStatus === 0">
           <div>
             <span class="status-pendding px-1 leading-22 ml-2 rounded-sm inline-block">审核中</span>
           </div>
          </template>
          <template v-if="smsResult.auditStatus === 2">
            <div>
              <span class="status-fail px-1 leading-22 ml-2 rounded-sm">短信审核已拒绝，请按照要求重新提交审核。</span>
            </div>
          </template>
        </div>
        <div v-if="[0,3].includes(smsResult.auditStatus)">
          <div class="mt-2 font-normal leading-5 text-theme-black-650 text-sm">
            由于短信运营商的限制，短信群发需要进行内容审核，审核通过后将立即为您发送短信，如有疑问，请扫码联系客服
          </div>
          <div class="customer mt-6 mb-4">
            <div class="flex">
              <div class="flex-col pr-10" :class="{'qr-right':!customerUserInfo.weixinBinding}">
                <p class="qr-text text-theme-black-850">如有疑问，请 <span class="font-semibold">扫码联系客服</span></p>
                <img :src="baseUrl+'img/code/Customer.Service.png'" class="w88 mt-1"><br>
              </div>
              <div class="flex-col pl-10" v-if="!customerUserInfo.weixinBinding">
                <p class="bind-weiChat text-theme-black-850 mb-1">绑定微信，可实时获取审核结果</p>
                <el-button type="primary" size="small" @click="bindWeiChat">绑定微信</el-button>

              </div>
            </div>
          </div>
        </div>
        <div v-else-if="smsResult.auditStatus === 2" class="custom-survey mt-6">
          <div class="survey-items flex items-start mb-3">
            <div class="survey-key w-36 text-theme-black-450 text-sm">问卷内容拒绝原因</div>
            <div class="survey-value flex max-w-md text-sm text-theme-black-850 leading-5">
              {{ smsResult.comment }}
            </div>
            <div class="btn-update ml-3" @click="updateSurvey">去修改问卷</div>
          </div>
<!--          <div class="survey-items flex items-start mb-3">-->
<!--            <div class="survey-key w-36 text-theme-black-450 text-sm">问卷内容拒绝原因</div>-->
<!--            <div class="survey-value flex max-w-md text-sm text-theme-black-850 leading-5">-->
<!--              {{ smsDetailsInfo.customSmsReject }}-->
<!--            </div>-->
<!--            <div class="btn-update ml-3" @click="updateSms">去修改短信</div>-->
<!--          </div>-->
          <div class="flex items-center mt-6">
            <el-button
                type="primary"
                size="small"
                :disabled="isDisabledBtnCpd"
                @click="submitAuditFun"
                :loading="reExamineLoading"
            >重新提交审核</el-button>
            <el-button type="text" @click="cancel">暂不发送短信，取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <PersonalMsg v-if="personalMsgShow" :personalMsgShow="personalMsgShow" @onCloseDialog="personalMsgShow = false"
                 :openQrCode="true" />
  </div>
</template>
<script>
import { getSurveyDomain } from '@/assets/js/config/env'
import PersonalMsg from '@/layout/components/PersonalMsg.vue'
import GlobalConfig, { AuthConfig } from '@/global/config'
import { mapGetters } from 'vuex'
import { submitAuditH } from '@/api/wenjuan/wjquestion'
import { getQuerySmsAuditH, refundSmsH } from '@/api/wenjuan/sample_new'
import { closeAudit, getSmsAudit } from '@/api/pay/sms'
import { getSmsTemps } from '@/api/wenjuan/publish'
import { getTempObjectFn } from '@/views/survey/publish/config/sms-sending'
import FixedTooltip from '@/components/tooltip/FixedTooltip.vue'
import { surveyVersionMixin } from '@/mixins/survey-mixin'

const baseUrl = getSurveyDomain()
export default {
  mixins: [surveyVersionMixin],
  inject: {
    source: {
      default: () => ({})
    },
    nextStep: {
      default: null
    }
  },
  computed: {
    ...mapGetters(['customerUserInfo', 'userInfo']),
    isDisabledBtnCpd() {
      return this.releaseVersionId === this.smsResult.versionId
    },
    moneyCpd() {
      return this.source.money
    },
    commentCpd() {
      return this.source.comment
    }
  },
  data() {
    return {
      reExamineLoading: false,
      // baseUrl
      personalMsgShow: false,
      examineDetails: {
        //审批状态 0取消 1待审批 2审批通过 3审批驳回
        examineStatus: 1, // 1审核中 2短信额度审核拒绝 3短信额度审核通过,进入短信群发审核 4短信群发拒绝
        examineInfo: '',
      },
      smsDetailsInfo: {
        smsQuantity: 0,
        smsPerson: 0,
        chartNum: 0,
        smsTotalAmount: 0,
        projectName: '',
        projectId: null,
        departmentName: '',
        smsTemplate: '',
        customSurveyReject: '',
        customSmsReject: '',
        id: null,
      },
      smsResult:{
        auditStatus: 3
      },
      changeDialogVisible: false, // 问卷审核弹窗
      refundDialogVisible: false, // 退款弹窗
    }
  },
  components: {
    FixedTooltip,
    PersonalMsg
  },
  activated() {
    this.getQySmsAudit()
  },
  created() {
    this.getQySmsAudit()
  },
  methods: {
    getQySmsAudit() {
      if (!this.userInfo.isQY) return
      getSmsAudit(GlobalConfig.getSurveyId()).then(res => {
        if (res.data?.data) {
          const data = res.data.data
          this.smsDetailsInfo = { ...this.smsDetailsInfo, ...data }
          // this.smsDetailsInfo.projectName = data.projectName
          // this.smsDetailsInfo.smsPerson = data.smsPerson
          // this.smsDetailsInfo.smsQuantity = data.smsQuantity
          // this.smsDetailsInfo.smsTotalAmount = data.smsTotalAmount
          // this.smsDetailsInfo.departmentName = data.departmentName
          // this.smsDetailsInfo.projectId = data.projectId
          // this.smsDetailsInfo.id = data.id
          this.examineDetails.examineStatus = data.examineStatus
          this.examineDetails.examineInfo = data.examineInfo
          if (this.examineDetails.examineStatus === 2) {
            getQuerySmsAuditH({ surveyId: GlobalConfig.getSurveyId() }).then(res => {
              this.smsResult = res.data.data
            })
          }
          getSmsTemps().then(res => {
            const list = res.data.data
            const objectFn = getTempObjectFn(list)
            const fn = objectFn[`smsTempText${data.smsTemplateType}`]
            this.smsDetailsInfo.smsTemplate = fn ? fn({ code: GlobalConfig.getSurveyId() }) : ''
            this.smsDetailsInfo.chartNum = this.smsDetailsInfo.smsTemplate.length
            console.log("this.smsDetailsInfo.smsTemplate ", this.smsDetailsInfo.smsTemplate )
          })
        }
      })
    },
    bindWeiChat() {
      this.personalMsgShow = true
    },
    // 修改审核
    updateExamine() {
      this.$surveyBus.$emit('updateStep', {
        step: 1,
        isExamine: true,
        data: {
          ...this.smsDetailsInfo,
          smsContent: this.smsDetailsInfo.smsTemplate
        }
      })
    },
    // 修改问卷
    updateSurvey() {
      const scene = this.$route.query?.scene
      this.$router.push({
        path: `/survey/${GlobalConfig.getSurveyId()}/edit?scene=${scene}`,
      })
    },
    // 修改短信
    updateSms() {
      this.$surveyBus.$emit('updateStep', { step: 1 })
    },
    // 重新提交审核
    submitExamine() {
      this.changeDialogVisible = true
    },
    // TODO 提交审核
    submitAuditFun() {
      const { freezesNo, recordId, money } = this.smsResult
      this.reExamineLoading= true
      submitAuditH({
        surveyId: GlobalConfig.getSurveyId(),
        sensitive: freezesNo + '@' + recordId + '@' + money,
        examineType: 1
      }).then(res => {
        if (res.code === 1) {
          this.$message({
            message: '提交审核失败',
            type: 'error'
          })
          return
        }
        this.$message({
          message: '提交审核成功',
          type: 'success'
        })
        getQuerySmsAuditH({ surveyId: GlobalConfig.getSurveyId() }).then(res => {
          this.smsResult = res.data.data
        })
        // this.changeDialogVisible = false
        // this.nextStep(3)
      }).catch(()=>{
        this.reExamineLoading = false
      })
    },
    // 确认取消退款
    confirmRefundFun() {
      this.refundDialogVisible = false
      const { recordId, freezesNo } = this.source
      refundSmsH({ recordId, freezesNo }).then(res => {
        if (res.code === 1) {
          this.$message({
            type: 'error',
            message: '退款失败'
          })
          return
        }
        this.$message({
          type: 'success',
          message: '退款成功'
        })
        this.nextStep(0)
      })
    },
    // 取消
    cancel() {
      // this.refundDialogVisible = true
      refundSmsH({
        ...this.smsResult
      }).then(()=>{
        this.$surveyBus.$emit('updateStep', { step: 0 })
        this.$message({
          type: 'success',
          message: '取消成功'
        })
      })
    },
    onCancel() {
      closeAudit(this.smsDetailsInfo.id).then(res => {
        if (res.data.code !== 0) {
          return this.$message.error(res.data.msg || '服务错误')
        }
        this.$message.success('取消审核')
        this.$surveyBus.$emit('updateStep', { step: 0 })
      })
    }
  },
  mounted() {
    console.log('GlobalConfig.getCurCompanyCode()', GlobalConfig.getCurCompanyCode())
    console.log('AuthConfig', AuthConfig)
  }
}
</script>
<style lang="scss" scoped>
$pendding-color: #E8A31B;
$success-color: #00BE6A;
$fail-color: #E34152;
::v-deep .el-dialog {
  &__header {
    height: 48px;
    background: #f5f7fa;
    border-radius: 4px 4px 0 0;
    padding: 0 16px;
  }

  &__title {
    height: 22px;
    font-weight: 400;
    font-size: 18px;
    color: rgba($color: #000000, $alpha: 0.85);
    text-align: left;
    line-height: 22px;
  }

  &__body {
    padding: 16px;

    div {
      line-height: 20px;
    }
  }

  &__footer {
    border-top: 1px solid rgba($color: #000000, $alpha: 0.1);
    padding-top: 17px;
    padding-bottom: 16px;
  }
}

.btn-update {
  font-size: 14px;
  @apply text-theme border border-solid border-theme;
  //height: 24px;
  line-height: 22px;
  padding: 1px 8px;
  border-radius: 2px;
  cursor: pointer;
}

.process-items {
  &:last-child .line {
    display: none;
  }


  .time-line {
    i {
      display: block;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      border: 1px solid #ccc;
      color: #ccc;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      font-style: normal;
      margin: 0 auto;
    }

    .icon-duigou {
      background: url('~@/assets/img/icon-duigou.png');
      background-size: 100% 100%;
      border: none;
    }

    .line {
      width: 1px;
      height: calc(100% - 40px);
      background: rgba(0, 0, 0, .15);
      margin: 0 auto;
      margin-top: 16px;
      margin-bottom: 16px;
    }

    .active-col {
      background: #2775E8
    }
  }

  .sms-title {
    font-size: 16px;
  }

  .status-pendding {
    border: 1px solid $pendding-color;
    font-size: 12px;
    font-weight: 400;
    color: $pendding-color;
  }

  .status-success {
    border: 1px solid $success-color;
    font-size: 12px;
    font-weight: 400;
    color: $success-color;
  }

  .status-fail {
    border: 1px solid $fail-color;
    font-size: 12px;
    font-weight: 400;
    color: $fail-color;
  }

  .sms-links {
    background-color: #f5f5f5;
    @apply rounded-small
  }

  .label {
    height: 22px;
    opacity: 0.45;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: right;
    line-height: 22px;
    width: 108px;

    &::after {
      content: ":";
      margin-left: 2px;
      margin-right: 4px;
    }
  }

  .value {
    min-width: 127px;
    font-weight: 400;
    font-size: 14px;
    color: #000000d9;
    line-height: 22px;
  }

  .customer {
    .w88 {
      width: 88px;
      height: 88px;
    }

    .qr-right {
      border-right: 1px solid rgba(0, 0, 0, .15);
    }

    .qr-text {
      color: #000000d9;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
    }

    .bind-weiChat {
      font-weight: 400;
      font-size: 14px;
    }
  }
}
</style>
